import { useState, useCallback, useEffect } from 'react'
import moment from 'moment';
import { Avatar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, Skeleton, Theme, Typography, useTheme } from '@mui/material'

import { PlusIcon } from '../../../../assets/SvgIcons'
import { useHistory } from 'react-router'
import AddBankModal from '../../common/AddBankModal'
import { useDispatch, useSelector } from "react-redux";
import { getMandateCreationDetails, getMandateRegistered, getMandatesList } from '../../../../redux-store/actions/investorProfile'
import { GetMandateCreationDetailsResponseBody, GetMandateRegisteredResponseBody, MandateCreation, MandateListItem, MandatesListResBody } from '../../../../redux-store/types/investorProfile'
import { toINR } from '../../../../utils/utilityFunctions'
import React from 'react'
import { navigationData } from '../../types';
import { RootStateType } from '../../../../redux-store/reducers';
import { showError } from '../../../../redux-store/actions/auth';
import { HELDAWAY_PORTFOLIO_STATUS, PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED, USER_ROLES } from '../../../../utils/constant';

interface Values {
    amount: string;
    accountNo: string;
    ifscCode: string;
    bankName: string;
    // months: string;
}

// const tabList = ['All', 'Active', 'Under Process']


function Mandates(props: navigationData): JSX.Element {
    const { clientCode } = props
    const history = useHistory();
    const dispatch = useDispatch();
    const { palette, typography } = useTheme()
    const [open, setOpen] = useState<boolean>(false);
    const [bankMandateDetailsRes, setBankMandateDetailsRes] = useState<Array<MandateCreation>>([]);
    const [mandateRequestDialog, setMandateRequestDialog] = useState<boolean>(false);
    const [mandateFormValues, setMandateFormValues] = useState<Values>({
        amount: '',
        accountNo: '',
        ifscCode: '',
        bankName: '',
        // months: ''
    });

    const [registerMandateRes, setRegisterMandateRes] = useState({})
    const [bankMandatesList, setBankMandatesList] = useState<Array<MandateListItem>>([]);
    const [filteredList, setFilteredList] = useState<MandatesListResBody>({} as MandatesListResBody);
    const [loading, setLoading] = useState<boolean>(false);
    const [fileId, setFileId] = useState<string>('');
    const [tabList, setTabList] = useState([{
        label: 'All',
        count: 0,
    }, {
        label: 'Active',
        count: 0,
    }, {
        label: 'Under Process',
        count: 0,
    },]);
    const [activeTab, setActiveTab] = useState(tabList[0].label)

    const { selectedPortfolio, isPortfolioHeldaway } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { investorClientId } = useSelector((state: RootStateType) => state.id)
    const { role } = useSelector((state: RootStateType) => state.auth)
    // console.log('clientCode', clientCode)
    const clientCodePayload = {
        clientCode: clientCode || investorClientId,
        portfolioId: selectedPortfolio?.value
    }

    const handleTabClick = (value: string) => {

        setActiveTab(value)
        if (value === 'All') {
            setBankMandatesList(filteredList?.mandates ?? []);
        }
        else if (value === 'Active') {
            const checkValue = 'approved';
            setBankMandatesList(filteredList?.mandates?.filter((item) => item.status?.toLowerCase() === checkValue))
        }
        else if (value === 'Under Process') {
            const mandatesUnderProcess = filteredList?.mandates?.filter((item) => item.status?.toLowerCase() !== 'approved');
            setBankMandatesList(mandatesUnderProcess);
        }
    }

    const handleBankClose = useCallback(() => {
        setOpen(false)
    }, [])

    const handleMandateModal = async () => {
        if (isPortfolioHeldaway) {
            dispatch(showError(HELDAWAY_PORTFOLIO_STATUS))
            return
        }

        setOpen(true);
    }

    const actype = bankMandateDetailsRes?.[0]?.bankAccountType === "SAVING" ? "1" : "2";

    const transformItem = (item: any) => {
        return {
            ...item,
            loading,
            clientCode
        }
    }

    useEffect(() => {
        const fetchInitialMandates = async () => {
            try {
                setLoading(true);
                const list = await (dispatch(getMandatesList(clientCodePayload)) as unknown as Promise<MandatesListResBody>);
                setBankMandatesList(list?.mandates ?? list ?? []);
                setFilteredList(list)
                setTabList([
                    {
                        label: 'All',
                        count: list?.mandates?.length ?? 0
                    },
                    {
                        label: 'Active',
                        count: list?.mandates?.filter((item) => item.status === 'APPROVED')?.length ?? 0
                    },
                    {
                        label: 'Under Process',
                        count: list?.mandates?.filter((item) => item.status !== 'APPROVED')?.length ?? 0
                    },
                ])
            } catch (e) {
                console.log("Error", e);
            } finally {
                setLoading(false);
            }
        }
        if (!open) fetchInitialMandates();
    }, [open])




    return (
        <Box
            sx={{
                background: palette.common.white,
                borderRadius: '25px',
                padding: '35px',
                border: `3px solid ${palette.stroke.main}`
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{
                    ...typography.h3,
                    color: palette.text.primary
                }}>Bank Mandates</Typography>
                {[USER_ROLES.INVESTOR,USER_ROLES.RM].includes(role) && <Box component={'button'}
                    onClick={handleMandateModal}
                    sx={{ cursor: 'pointer', outline: 'none', border: 'none', background: palette.primary[500], padding: { xs: '5px', md: '15px' }, borderRadius: '10px', display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                    <PlusIcon />
                    <Typography sx={(theme: Theme) => (
                        {
                            // fontSize: ['14px', '16px'],
                            // ...typography.subtitle_500,
                            fontWeight: [500, 600],
                            // fontWeight:600
                            color: palette.common.white,
                            ...theme.typography.subtitle_500
                        }
                    )}>Create a new Mandate</Typography>
                </Box>}
            </Box>
            <Box sx={{ marginTop: '20px', overflow: 'auto', width: '100%' }}>
                <Box sx={{ borderBottom: `1px solid ${palette.text.secondary}99`, display: 'flex', flexDirection: 'row', gap: '10px' }}>
                    {tabList.map((item, index) => (
                        <Box key={index + item?.label}
                            onClick={() => activeTab !== item?.label && handleTabClick(item?.label)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '10px',
                                background: activeTab === item?.label ? palette.primary[500] : palette.grey[50],
                                borderRadius: '7px 7px 0px 0px',
                                padding: '5px 15px',
                                cursor: 'pointer',
                                alignItems: 'center',
                            }}>
                            <Typography color={activeTab === item?.label ? palette.textDark.primary : palette.text.secondary} variant='body_500' sx={{ wordBreak: 'keep-all' }}>{item?.label}</Typography>
                            <Typography
                                component={'span'}
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    padding: '0px 10px',
                                    height: { xs: '20px', md: '25px' },
                                    backgroundColor: activeTab === item?.label ?
                                        theme.palette.common.white :
                                        theme.palette.primary[50],
                                    color: theme.palette.primary[500],
                                    borderRadius: '7px',
                                    letterSpacing: '0.02px',
                                    // mt: '3px',
                                    // mb: '3px',
                                    // lineHeight: '20px'
                                })}
                            >
                                {item?.count}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box sx={{ marginTop: '25px', display: 'flex', flexDirection: 'column', gap: '35px' }}>
                {loading ? (
                    [...Array(3)].map((item, index) => (
                        <Box key={index}>

                            <Box >
                                <Box sx={{
                                    background: palette.grey[50],
                                    padding: '25px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}>
                                    {/* fund details */}
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
                                        <Skeleton animation="wave" variant='rectangular' width={'45px'} height={'45px'} sx={{ borderRadius: '50%' }} />
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            <Skeleton animation="wave" sx={{ width: '80px' }} />
                                        </Box>

                                        <Box sx={{ ml: '50px' }}>
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            <Skeleton animation="wave" sx={{ width: '80px' }} />
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Skeleton animation="wave" variant='rectangular' width='250px' height="50px" />
                                    </Box>
                                    {/* list for details */}
                                </Box>
                            </Box>
                            <Grid container mt={'25px'} pr={'25px'} pl={'25px'} rowGap={{ lg: '45px', md: '20px', sm: '20px', xs: '10px' }} >
                                {[...Array(8)].map((item, index) => (
                                    <Grid key={index} item lg={3} md={4} sm={6} xs={12}>
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            <Skeleton animation="wave" sx={{ width: '60px' }} />
                                        </Box>
                                    </Grid>

                                ))}
                            </Grid>

                        </Box>
                    ))
                )
                    : bankMandatesList?.length === 0 ? (
                        <Typography sx={{ textAlign: 'center', mt: '20px' }} variant='h2' color={'text.primary'}> No Results Found</Typography>
                    ) : bankMandatesList?.filter(item => item.accountType !== null).map((item, index) => (
                        <div key={index}>
                            <Card {...transformItem(item)} />
                            {bankMandatesList?.length - 1 !== index && <Divider sx={{ marginTop: '20px' }} />}
                        </div>
                    )
                    )}


            </Box>
            {open &&
                <AddBankModal
                    {...{
                        handleClose: handleBankClose,
                        open,
                        setOpen,
                        setActiveTab,
                        title: 'Add New Bank Mandate',
                        // bankMandateDetails: bankMandateDetailsRes,
                        clientCode: clientCode,
                        mandateRequestDialog,
                        setMandateRequestDialog,
                        mandateFormValues,
                        setMandateFormValues,


                    }}
                />
            }

        </Box>
    )
}

export default Mandates

type CardProps = {
    loading?: boolean,
    mandateId: string,
    months: string,
    mandateType: string,
    amount: string,
    accountNo: string,
    ifscCode: string,
    bankName: string,
    status: string,
    fileKey: string,
    accountType: string,
    uploadFlag: boolean | null,
    startDate: string
    clientCode: string;
    uploadKey: boolean;
}

const Card = (props: CardProps) => {
    const { mandateId, months, status, mandateType, amount, accountNo, bankName, ifscCode, fileKey, accountType, startDate, clientCode } = props
    const { palette, typography } = useTheme()
    const history = useHistory();
    const { pathname: pathName, state } = history.location;

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const formUploaded = (state as { formUploaded?: boolean })?.formUploaded ?? false;

    return (
        <Box>
            <Box sx={{
                background: palette.grey[50],
                padding: '25px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
                {/* fund details */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
                    <Avatar sx={{ width: '45px', height: '45px', borderRadius: "0px" }} alt='fund icon' src='/images/amcIcons/default.svg' />
                    <Box >
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 500,
                            color: palette.text.secondary
                        }}>Reference ID</Typography>
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 600,
                            color: palette.text.primary
                        }}>{mandateId}</Typography>
                    </Box>
                    <Box sx={{ ml: { xs: '15px', sm: '50px' } }}>
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 500,
                            color: palette.text.secondary
                        }}>Mandate Creation Date</Typography>
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 600,
                            color: palette.text.primary
                        }}>{moment(startDate, "YYYY-MM-DD HH:mm:ss.SSSZ").format("DD/MM/YYYY")}</Typography>
                    </Box>

                </Box>
                {mandateType !== "N" && (
                    <Box sx={{ display: { xs: 'none', sm: 'unset' } }}>

                        <Button
                            disabled={mandateType === "N" || `${status ?? ''}`.toUpperCase() !== PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED}
                            sx={{
                                cursor: 'pointer',
                                outline: 'none',
                                border: mandateType === "N" || `${status ?? ''}`.toUpperCase() !== PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED ? `1px solid ${palette.textDark.secondary}` : `1px solid ${palette.primary[500]}`,
                                padding: '15px',
                                borderRadius: '4px',
                            }}
                            onClick={() => history.push(`${pathName}/download-upload-xsip`, { downloadUploadFixture: { ...props, fileKey }, clientCode: clientCode })}
                        >
                            <Typography sx={{
                                ...typography.subtitle_300,
                                fontWeight: 600,
                                color: mandateType === "N" || `${status ?? ''}`.toUpperCase() !== PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED ? palette.textDark.secondary : palette.primary[500]
                            }}>Download and Upload Physical Mandate Form</Typography>
                        </Button>

                    </Box>
                )
                }
                {/* list for details */}
            </Box>
            <Grid container mt="25px" rowGap="15px" sx={{ flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'left' } }}>
                    <Item title='Mandate Type' subTitle={mandateType === "X" ? "Physical Mandate" : "E-Mandate"} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { xs: 'left', sm: 'center' } }}>
                    <Item title='Status' subTitle={status === "APPROVED" ? 'Active' : status} subTitleColor={status === "APPROVED" ? palette.success[500] : palette.warning[500]} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'center', xs: 'left' } }}>
                    <Item title='Mandate Limit' subTitle={toINR({ value: amount, locale, currencyCode })} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'right', xs: 'left' } }}>
                    <Item title='No. of Months' subTitle={months} subTitleAlign="right" />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' } }}>
                    <Item title='Bank' subTitle={bankName} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { lg: 'center', xs: 'center' } }}>
                    <Item title='Account Number' subTitle={accountNo} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { lg: 'center', xs: 'center' } }}>
                    <Item title='Account Type' subTitle={accountType} />
                </Grid>
                <Grid item sm={3} xs={12} sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: { sm: 'right', xs: 'left' } }}>
                    <Item title='IFSC Code' subTitle={ifscCode} titleAlign="right" />
                </Grid>

                {mandateType !== "N" && <Box sx={{ display: { sm: 'none' }, mt: { xs: 2, sm: 0 }, textAlign: 'center', width: "100%" }}>
                    <Button disabled={mandateType === "N" || `${status ?? ''}`.toUpperCase() !== PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED} sx={{ cursor: 'pointer', outline: 'none', border: mandateType === "N" || `${status ?? ''}`.toUpperCase() !== PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED ? `1px solid ${palette.textDark.secondary}` : `1px solid ${palette.primary[500]}`, padding: '10px', borderRadius: '4px', width: "100%" }}
                        onClick={() => history.push(`${pathName}/download-upload-xsip`, { downloadUploadFixture: { ...props, fileKey, clientCode: clientCode } })}
                    >
                        <Typography sx={{
                            ...typography.subtitle_300,
                            fontWeight: 600,
                            color: mandateType === "N" || `${status ?? ''}`.toUpperCase() !== PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED ? palette.textDark.secondary : palette.primary[500]
                        }}>Download and Upload Physical Mandate Form</Typography>
                    </Button>
                </Box>}
            </Grid>
        </Box>
    )
}

type ItemProps = {
    title: string
    subTitle: string
    subTitleColor?: string
    subTitleAlign?: 'left' | 'right' | 'center'
    titleAlign?: 'left' | 'right' | 'center',
}

const Item = (props: ItemProps) => {
    const { palette, typography } = useTheme()

    return (
        <Box sx={{ display: { xs: 'flex', sm: 'unset' }, alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography
                sx={{
                    ...typography.body_500,
                    color: palette.text.secondary,
                    display: 'flex',
                    justifyContent: { xs: 'space-between', sm: props.titleAlign ? props.titleAlign : 'left' }
                }}>
                {props.title}
            </Typography>
            <Typography
                sx={{
                    ...typography.subtitle_300,
                    fontWeight: 600,
                    color: props.subTitleColor ? props.subTitleColor : palette.text.primary,
                    display: 'flex',
                    // justifyContent: { xs: 'space-between', sm: props.subTitleAlign ? props.subTitleAlign : 'left' },
                    alignSelf: 'left',
                    justifySelf: 'left'
                }}>
                {props.subTitle}
            </Typography>
        </Box>
    )
}